import { api } from "@/services/api"

export type RetrievePaymentCheckoutResponse = {
  merchantID: string
  action: "SALE"
  countryCode: "826"
  currencyCode: "826"
  amount: string
  orderRef: string
  transactionUnique: string
  formResponsive: "Y"
  redirectURL: string
  callbackURL: string
  merchantName: string
  walletStore: "Y"
  walletOwnerRef: string
  avscv2CheckRequired: "N"
}

export const retrievePaymentCheckout = async (
  paymentRequestId: string
): Promise<RetrievePaymentCheckoutResponse> => {
  const { body } = await api.post<
    RecursivelyConvertDatesToStrings<RetrievePaymentCheckoutResponse>
  >(
    `/beepaidgo/payment-requests/${paymentRequestId}/checkout/`
  )

  return body
}
